
<template>
<modal name="modal-refer"
        transition="nice-modal-fade"
        :min-width="200"
        :min-height="200"
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="true"
        :reset="true"
        width="500"
        height="auto"
        @before-open="beforeOpen" >
    <div class="modal_wrapper card_share_dropdown account panel_bc " >
       <div slot="top-right">
            <button @click="$modal.hide('modal-refer')" class="ngdialog-close"></button>
        </div>
        <div class="card container panel_bc">
            <div class="mt20 card_section_head pr-0">
                <h4 class="mb10 text-left">{{$t('refer.title')}}</h4>
            </div>
            <p class="mb10 d_block t_11px text-left ">{{$t('refer.titlesub')}}</p>
            <div class="form-group inputycopy ">
                <label class="mt10">{{$t('refer.link')}}</label>
                <div class="d-flex align-items-center">
                    <input id="copiarurl" class="form-control dark manito" style="width:95%" @click="openLinckard()" type="text" :value="getLinkcardURL()" readonly="readonly"><Icon style="width: 5%; cursor: pointer;" @click.native="doCopy" icon="ph:copy-light" />
                </div>
            </div>
            <label class="mt10">{{$t('refer.linkshare')}}</label>
            <ul class="list_social_inline mb10  " >
                <span style="width:20%" v-if="$util.isMobile()" tabindex="0"><li><a :href="'whatsapp://send?text='+$i18n.t('refer.share_titlesub')+' '+getLinkcardURL()" target="_blank" class="btnWhatsapp"><Icon icon="ph:whatsapp-logo-light" /></a></li></span>
                <span style="width:20%" v-else tabindex="0"><li><a :href="'https://api.whatsapp.com/send?text='+$i18n.t('refer.share_titlesub')+' '+getLinkcardURL()" target="_blank" class="btnWhatsapp"><Icon icon="ph:whatsapp-logo-light" /></a></li></span>   
                <social-sharing :url='getLinkcardURL()'  :title="$t('refer.share_title')"   :description="$t('refer.share_titlesub')"  twitter-user="linckard"  :networks="$util.overriddenNetworks(getLinkcardURL())"   v-cloak inline-template>
                <div class=" list_social_inline " >
                    <network network="email"><li><a class="btnEmail"><Icon icon="ph:envelope-simple-light" /></a></li></network>
                    <network network="messenger" v-if="$util.isMobile()" ><li><a class="btnMessenger"><Icon icon="ph:messenger-logo-light" /></a></li></network>
                    <network network="facebook"><li><a class="btnFacebook"><Icon icon="ph:facebook-logo-light" /></a></li></network>
                    <network network="linkedin"><li><a class="btnLinkedIn"><Icon icon="ph:linkedin-logo-light" /></a></li></network>
                    <network network="twitter"><li><a class="btnTwitter"><Icon icon="ph:x-logo-light" /></a></li></network>
                </div>
                </social-sharing>
            </ul>  
        </div>
    </div>
  </modal>
</template>
<script>

export default {
    data() {
        return {
            getUser:this.$store.state.userProfile,
        };
    },
    methods:{
        getLinkcardURL() {
            var dis=this
            let url=process.env.URL+'login?type=signup&friend='+this.getUser.uid.substring(1,10)+'&email='+this.getUser.email
            return url
        },
        openLinckard() {
            window.open(this.getLinkcardURL(), '_blank');
        },

        beforeOpen (event) {

        },
        doCopy() {
            var dis=this
            if(process.client){
                document.getElementById("copiarurl").select()
                document.execCommand("copy");
                this.$util.notif_success(this.$t('firma.docopy'))
            }
        },
    },
    computed:{
        wpweb(){
            return 'wpweb_'+this.id
        },
        messenger(){
            return 'msg_'+this.id
        },
    },
}

</script>

